import {InvoiceTypeList} from './_models'

export const isInvoiceTypeAvailableForTemplate = (
  invoiceType: number,
  invoiceTemplate: number
): boolean =>
  InvoiceTypeList.some(
    (type) =>
      type.id === invoiceType &&
      type.isActive &&
      type.template?.some((template) => template.id === invoiceTemplate && template.isActive) ===
        true
  )
